export class Logger {
  private errorQueue: any[] = [];

  public captureError(error: any) {
    this.errorQueue.push(error);
  }
}

export const logger = new Logger();
